// extracted by mini-css-extract-plugin
export default {"modal-content":"deleteModal_modal-content__0QCby","icon-wrapper":"deleteModal_icon-wrapper__IG+fy","modal-title":"deleteModal_modal-title__BpYPH"};